"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var context_1 = require("../../../context");
var FormControl_1 = __importDefault(require("../../FormControl"));
var Input_1 = __importStar(require("../../Input"));
var NHSNumberInput = function () {
    var trans = context_1.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(FormControl_1.default, { errors: errors.nhs_number, dusk: "nhs-number-field", label: trans('optiiva::labels.nhs-number') },
        react_1.default.createElement(Input_1.default, { width: "xs", name: "nhs_number", maxLength: 20, type: Input_1.InputType.number, className: "form-input--disabled-spinner" })));
};
exports.default = NHSNumberInput;
//# sourceMappingURL=NHSNumberInput.js.map